import { FC, useEffect, useMemo, useState } from 'react'
import { WebsiteForm } from './WebsiteForm'
import styles from './Form.module.scss'
import { InvestmentForm } from './InvestmentForm'
import { useAppContext } from './../../hooks/useAppContext'
import { useLocation } from 'react-router-dom'
import { getParsedValuesFromUrlOrDefault } from './../../utils'
import { getTableValues } from '../../context/utils'

let isLoaded = false

export const Form: FC = () => {
    const { currentWebsiteFormData, newWebsiteFormData, investmentFormData, monthsForChart, setcurrentWebsiteFormData, setnewWebsiteFormData, setinvestmentFormData, setmonthsForChart, setTableValues } = useAppContext()
    const [toggleResetAllForms, setToggleResetAllForms] = useState<boolean>(false)
    const { pathname } = useLocation()
    const [currentWebsite, newWebsite, investmentData, month] = useMemo(() => getParsedValuesFromUrlOrDefault(pathname), [pathname])

    const handleCalculate = () => {
        setTableValues(getTableValues(currentWebsiteFormData, newWebsiteFormData, investmentFormData, monthsForChart))
    }

    useEffect(() => {
        if (!isLoaded) {
            setTableValues(getTableValues(currentWebsite, newWebsite, investmentData, month))
            setmonthsForChart(month)
            isLoaded = true
        }
    }, [month, setmonthsForChart])

    return (
        <section className={styles.section}>
            <div className={styles.formsContainer}>
                <WebsiteForm title={'Funnel metrics before'} setData={setcurrentWebsiteFormData} WEBSITE_FORM_DATA={currentWebsite} toggleResetAllForms={toggleResetAllForms} />
                <WebsiteForm title={'Funnel metrics after'} setData={setnewWebsiteFormData} WEBSITE_FORM_DATA={newWebsite} toggleResetAllForms={toggleResetAllForms} />
                <div className={styles.formContainer}>
                    <div className={styles.invContainier}>
                        <InvestmentForm toggleResetAllForms={toggleResetAllForms} setinvestmentFormData={setinvestmentFormData} WEBSITE_FORM_DATA={investmentData} />
                    </div>
                </div>
            </div>
            <div className={styles.btnWrapper}>
                <button className={`${styles.btn} ${styles.resetBtn}`}
                    onClick={() => setToggleResetAllForms(prev => !prev)}
                >Reset changes
                </button>
                <button className={`${styles.btn} ${styles.calculateBtn}`}
                    onClick={handleCalculate}
                >Calculate
                </button>
            </div>
        </section>
    )
}
